<template>
  <div class="ProductsServicesButtonModule" @mouseenter="mouseenterFn" @mouseleave="mouseleaveFn">
    <div class="name"><span>产品服务</span> <i class="iconfont icon-arrow-down-solid"></i></div>
    <div class="services-cont">
      <div v-for="item in data" :key="item.id" class="cont-item" :class="`cont${item.id}`">
        <div class="title">{{ item.name }}</div>
        <div class="item-box">
          <div
            class="item"
            v-for="itm in item.child"
            :key="itm.id"
            v-track
            :data-oid="2136"
            :data-extendinfo="itm.name"
            @click="handelClick(item.id, itm.id)"
          >
            <div class="img-box">
              <img :src="itm.icon" alt="" />
            </div>
            <div>
              <div class="name">{{ itm.name }} <em class="iconfont icon-a-bianzu11"></em></div>
              <div class="describe">{{ itm.describe }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ConstantsProductServicesData,
  ProductsServicesChildData,
} from "../../../utils/constants/constants.product-services-data";
import { PRODUCTS_SERVICES } from "../../../utils/constants/constants";

export default {
  name: "ProductsServicesButtonModule",
  components: {},
  data() {
    return {
      data: [],
    };
  },
  created() {
    this.data = ConstantsProductServicesData.map((item) => {
      item.child = ProductsServicesChildData[item.id];
      return item;
    });
  },
  mounted() {},
  methods: {
    mouseenterFn() {},
    mouseleaveFn() {},
    handelClick(pid, cid) {
      window.open(`${PRODUCTS_SERVICES}?id=${pid}&childId=${cid}`);
    },
  },
};
</script>

<style scoped lang="scss">
.ProductsServicesButtonModule {
  height: 48px;
  p {
    margin: 0;
    padding: 0;
  }
  img {
    margin: 0;
    padding: 0;
  }
  .name {
    font-size: 14px;
    color: #2a2b33;
    cursor: pointer;
    display: flex;
    line-height: 48px;
    em {
      font-size: 16px;
      transform: scale(0.5);
    }
    i {
      font-size: 10px;
      color: #bfc4cd;
      display: inline-block;
      transition: transform 0.3s ease;
      transform: scale(0.5);
    }
  }

  .services-cont {
    display: none;
    width: 851px;
    height: 570px;
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0px 4px 12px 1px rgba(22, 49, 77, 0.08);
    position: absolute;
    top: 44px;
    right: 70px;
    z-index: 222;
    padding: 20px;
    .cont-item {
      padding-bottom: 27px;
      &.cont1 {
        padding-top: 8px;
        padding-left: 6px;
        .title {
          padding-left: 14px;
        }
        .item-box {
          justify-content: space-between;
        }
      }

      &.cont2 {
        padding-left: 6px;
        .title {
          padding-left: 14px;
        }
        .item {
          margin-right: 13px;
        }
      }
      &.cont3 {
        background: rgba(244, 247, 250, 0.7);
        border-radius: 4px;
        padding: 20px 20px 17px;
        .item-box {
          justify-content: space-between;
        }
        .item {
          width: 227px;
          height: auto;
          padding: 0;
          margin: 13px 0;
          &:hover {
            background: rgba(244, 247, 250, 0.7);
            box-shadow: none;
          }
          .img-box {
            background-color: #fff;
          }
        }
      }
      .title {
        font-size: 18px;
        font-weight: 550;
        text-align: left;
        color: #2a2b33;
        line-height: 26px;
        margin-bottom: 7px;
      }
      .item-box {
        display: flex;
        flex-wrap: wrap;
      }
      .item {
        display: flex;
        align-content: center;
        width: 247px;
        padding: 12px;
        // height: 72px;
        cursor: pointer;
        margin-bottom: 2px;
        .img-box {
          width: 48px;
          height: 48px;
          background: #f4f7fa;
          border-radius: 4px;
          margin-right: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 30px;
          }
        }
        .name {
          font-size: 14px;
          font-weight: 550;
          color: #2a2b33;
          line-height: 22px;
          margin-bottom: 6px;
        }
        .describe {
          font-size: 12px;
          color: #a3a6ab;
          line-height: 20px;
        }
        &:hover {
          //width: 262px;
          //height: 72px;
          background: #ffffff;
          border-radius: 4px;
          box-shadow: 0px 2px 8px 0px rgba(22, 49, 77, 0.11);
          .name {
            color: #d06957;
          }
          .describe {
            color: #2a2b33;
          }
        }
      }
    }
  }

  &:hover {
    .name {
      color: #d06957;
      font-weight: 550;

      i {
        color: #d06957;
        transform: scale(0.5) rotate(180deg);
      }
    }

    .services-cont {
      display: block;
    }
  }
}
</style>
